export default __webpack_public_path__ + "static/media/edit.d3a3e644.svg";